<template>
  <div :style="pageStyle" class="page-land">
    <div class="page-tips-area" v-if="dataInfo.safetyVerificationFlag === '1'">
      <img class="check-icon" src="https://qianshoushoutest.oss-cn-hangzhou.aliyuncs.com/resources/images/check_icon_white.png">
      已通过安全验证，请放心使用！
    </div>
    <div v-show="!showADFlag">
      <div  class="qrcode-image" ref="qrcode_image" v-show="dataInfo.targetType == 3">
        <div class="show-img-content">{{contentText}}</div>
      </div>

      <div v-show="dataInfo.targetType != 3 && dataInfo.targetType != 16">
        <!-- 打开app -->
        <div class="open-app" v-show="dataInfo.targetType == 11">
          <div class="view-app">
            <img v-show="dataInfo.appIcon" class="app-icon" :src="dataInfo.appIcon" alt="">
          </div>
          <div class="open-app-btn-11">
            <div class="button-text" @click='oppApp'>{{dataInfo.buttonText}}</div>
          </div>
          <div class="text-content" >{{dataInfo.pageTextContent}}</div>
          <div class="view-img">
            <img v-if="dataInfo.showImgUrl" class='text-img' :src="dataInfo.showImgUrl" alt="">
          </div>
        </div>

        <div v-if="dataInfo.targetType == '8'">
          <div class="copy-content">{{dataInfo.pageTextContent}}</div>
          <div class="copy-show"  v-if="dataInfo.textCopyButtonFlag == '1'" >
            <div
              class="copy-button"
              v-clipboard:copy="dataInfo.pageTextContent"
              v-clipboard:success="onCopy"
              v-clipboard:error="onError"
            >{{dataInfo.textCopyButtonDescription}}</div>
          </div>
        </div>

        <div class="qrcode-main"  v-if="dataInfo.targetType != 22 && dataInfo.targetType != 23 && dataInfo.targetType != 8">
          <div v-if="dataInfo.targetType == 5" class="item-qrcode">
            <div class="item-copy">
              <p>二维码文本：</p>
              <img class="copy-qrcode"
                   v-clipboard:copy="dataInfo.qrCodeContent"
                   v-clipboard:success="onCopy"
                   v-clipboard:error="onError"
                   src="https://qianshoushoutest.oss-cn-hangzhou.aliyuncs.com/resources/images/icons/copy21.png" alt="">
            </div>
            <div class="qrcode-url">{{dataInfo.qrCodeContent}}</div>
          </div>
          <div class="qrcode-item" ref="qrcode_box">
            <div class="qrcode"  v-if="dataInfo.targetType == 0 || dataInfo.targetType == 4 || dataInfo.targetType == 5" id="qrCode" ref="qrCode"></div>
            <img v-if="dataInfo.targetType == 5"  @click="download" class="download" src="https://qianshoushoutest.oss-cn-hangzhou.aliyuncs.com/resources/images/icons/download.png" alt="">
          </div>
          <div v-if="dataInfo.targetType == 1">
            <img class="image"  :src="dataInfo.qrCodeContent" alt="">
            <!-- <img class="image"  src="@/img/123.jpg" alt=""> -->
          </div>
          <div v-if="dataInfo.targetType != 5 && dataInfo.targetType != 7"  class="text-content" >{{contentText}}</div>
          <!-- 打开小程序 -->
          <div class="wecaht"  v-if="dataInfo.targetType == 7">
            <img class="wecaht-img" :src="dataInfo.weChatMiniProgramImgUrl" v-if="dataInfo.weChatMiniProgramImgUrl" alt="">
            <div id='launch-btn2'>
              <button class="wechat-btn2" style="height: 40px; width: 300px;border-radius: 20px;font-size: 16px;bottom:-100px">
                {{loadingStatus == 'success' ? (dataInfo.buttonText || dataInfo.weChatMiniProgramButtonText) : '加载中请稍等...'}}
              </button>
            </div>
            <div class="wechat-text-content" v-if="dataInfo.pageTextContent">{{dataInfo.pageTextContent}}</div>
            <div id='launch-btn' style="bottom: -100px;"></div>
          </div>
        </div>
      </div>
      <!-- 单页面 -->
      <single-page :dataInfo='dataInfo' v-if="dataInfo.targetType == 16" @changeBtn="changeBtn"></single-page>
      <wechat-open-app ref="open_app" :dataInfo='dataInfo' ></wechat-open-app>
      <!-- 授权审批 -->
      <div v-show="dataInfo.targetType == 18" class="action-qss-auth">
        <img class="header" src="https://qianshoushoutest.oss-cn-hangzhou.aliyuncs.com/resources/images/h5/logo.png" alt="">
        <div class="name">钱收收</div>
        <div class="content">
          <span v-if="dataInfo.authDeviceModel">{{dataInfo.authDeviceModel}}</span>
          <span v-if="modelInfo[dataInfo.authApp]">({{modelInfo[dataInfo.authApp]}})</span>
          申请获取以下权限,将用于该设备的登录
        </div>
        <div class="tip">获取您的公开信息(头像、昵称等)</div>
        <div class="btn-confirm" @click="handleLoginApplication(2)">同意</div>
        <div class="btn-cancel"  @click="handleLoginApplication(1)">拒绝</div>
      </div>
      <!--打开微信群-->
      <!--打开微信号-->
      <div class="wechat-id" v-show="dataInfo.targetType == 22 || dataInfo.targetType == 23">
        <div class="qrcode" id="wechatQrCode" ref="wechatQrCode"></div>
        <div class="info-area" v-show="dataInfo.available">
          <div class="info-box">
            <img class="avatar" v-if="dataInfo.avatarUrl" :src="dataInfo.avatarUrl" alt="">
            <div class="nickname">{{dataInfo.name}}</div>
            <img class="gender" v-if="dataInfo.gender == 1" src="https://qianshoushoutest.oss-cn-hangzhou.aliyuncs.com/resources/images/qrcode_male.png" alt="男">
            <img class="gender" v-if="dataInfo.gender == 2" src="https://qianshoushoutest.oss-cn-hangzhou.aliyuncs.com/resources/images/qrcode_female.png" alt="女">
            <img class="gender" v-if="dataInfo.type == 1" src="https://qianshoushoutest.oss-cn-hangzhou.aliyuncs.com/resources/images/wechat_company.png" alt="企业微信">
          </div>
          <div class="qr-code-box">
            <div ref="wechat_qrcode" class="class-qrcode"></div>
          </div>
          <div class="time" v-if="dataInfo.targetType == 23 || dataInfo.expireTime">
            有效时间：{{dataInfo.expireTime}}
          </div>
        </div>
        <div class="tips" v-if="dataInfo.available">
          {{dataInfo.pageTextContent}}
        </div>
        <div  class="tips" v-else>暂无可扫描二维码</div>
        <div class="service-box" v-if="dataInfo.available">
          <div class="service-item" v-for="(item, key) in dataInfo.contactMap">
            <div v-if="key == 2">联系电话：{{item}}</div>
            <!--<div v-if="key == 0">在线客服</div>-->
          </div>
        </div>
      </div>
      <footer class="page-footer" v-if="!!dataInfo.techProviderUrl">
        <div class="tips"></div>
        <div class="tips" @click="toURL">此页面由<span class="url-tips">{{dataInfo.techProviderUrlForShow+'('+dataInfo.techProviderName+')'}}</span>灵活码系统自动生成</div>
      </footer>
    </div>
    <!--显示广告-->
    <div v-if="showADFlag" class="ad-area">
      <div class="ad-box">
        <iframe v-if="adSrc" name="ad" :src="adSrc" class="class-iframe"></iframe>
        <img v-else class="ad-image" src="https://qianshoushoutest.oss-cn-hangzhou.aliyuncs.com/resources/images/h5/qrcodeAD.png">
      </div>
      <div class="close-box" @click.stop="jumpAD">
        <div class="close-button">跳过</div>
      </div>
    </div>
  </div>
</template>


<script>
import QRCode from "qrcodejs2";
import {getAction,singlePageClick, getCallBackDomain, handleLoginApplication} from '@/api/qrcode'
import { getWechatPublicAuthorizationUrl,newLogin } from '@/api/login'
import { Toast } from 'vant';
import { initWx, wx_launch, is_weixn } from '../../js/wx'
import wx from 'weixin-js-sdk'
import  uni from '../../js/uni.webview.1.5.2'
import ant from '../../js/antbridge.min'
import WechatOpenApp from "./components/wechat-open-app.vue"
import SinglePage from "./components/single-page.vue"
import {getCookie, setCookie, clearAllCookie } from '@/utils/tool'
import {getTokenFromSession} from '../../api/qrcode';
import qs from "qs";
export default {
  components:{
    WechatOpenApp,
    SinglePage
  },
  props: {
    cookie:{}
  },
  data() {
    return{
      //进入页面第一次获取动作
      isFirstGetAction: true,
      adSrc: '',
      //没有扫码次数，先显示广告，显示广告的标志
      showADFlag: false,
      //是否用户未经观看过广告
      // isNotShownFlag: true,
      dataInfo:{},
      popup: 0,
      url: '',
      loadingStatus: 'loading',
      /** 显示的文本 */
      contentText: '',
      // getAction 所需参数
      content:'',
      isIos:false,
      iframeSrc: '',
      modelInfo: {
        0: '微信',
        1: '支付宝',
        2: '钱收收',
        3: '浏览器及其他'
      },
    }
  },
  mounted() {
    if(this.$route.query.token) {

      localStorage.setItem('token', this.$route.query.token)
    }
    const token = localStorage.getItem('token')
    /** 判断是否是授权回来的 */
    if(this.$route.query.code) {
      this.weChatPublicAuthLogin()

    } else {
      // 携带cookie
      if(this.$route.query.session) {
        setCookie('SESSION',this.$route.query.session, 360)
      }
      this.getTokenFromSession()
    }
  },
  computed: {
    pageStyle() {
      return {
        backgroundColor: (this.dataInfo.targetType == 22 || this.dataInfo.targetType == 23) ? '#eee' : '#fff'
      }
    },
    isWeChat() {
      const ua = navigator.userAgent.toLowerCase();
      let arr = ua.match(/MicroMessenger/i) || []
      return arr.includes("micromessenger")
    },
  },
  methods: {
    //尝试获取token
    async getTokenFromSession() {
      try {
        const res = await getTokenFromSession()
        if(res.mdata.token) {
          localStorage.setItem('token', res.mdata.token)
        }
      } catch (e) {
        console.log(e)
      }
      this.getAction()
    },

    async getCallBackDomain() {
      const { protocol, origin,  pathname, hostname, href} = window.location
      const res = await getCallBackDomain()
      // const res = {
      //   mdata: {
      //      callBackDomain: 'testcallback.qianshoushou.com',
      //   }
      // }
      const {callBackDomain} = res.mdata
      this.iframeSrc = `${protocol}//${callBackDomain}/one.html`
    },
    async getAction(){
      const { protocol, origin,  pathname, hostname, href} = window.location
      const routeInfo = {
        path: href.split('?')[0],
        query: qs.parse(href.split('?')[1] || '{}')
      }
      const qrCodeNo = (((routeInfo.path || '').split('ql/')[1] || '').match(/\d+/g) || [])[0]
      const content = href
      this.content = content
      try {
        const params = {
          content,
          accessHandleModeNo: '',
          redirectEntryUrlFlag: false
        }
        //是二维码页面才执行
        if(qrCodeNo){
          const sessionAccessHandleModeNo =  sessionStorage.getItem(qrCodeNo) || ''
          //根据条件判断是否需要执行指定动作或者进行重定向到二维码页面
          if(sessionAccessHandleModeNo && routeInfo.query.accessHandleModeNo) {
            //值不同
            if(sessionAccessHandleModeNo === routeInfo.query.accessHandleModeNo) {
              //是第一次获取
              if(this.isFirstGetAction) {
                params.accessHandleModeNo = sessionAccessHandleModeNo
              } else {
                //正常进行
              }
            }
            //值不同（部分异常）
          } else if (sessionAccessHandleModeNo) {
            //只有sessionStorage中有，正常进行后续动作（部分异常）
            // params.redirectEntryUrlFlag = true
          } else if (routeInfo.query.accessHandleModeNo) {
            //只有路径中有，说明是通过分享进来的
            params.redirectEntryUrlFlag = true
          } else {
            //两个都没有说明是第一步，正常进行后续操作
          }
        }
        const res = await getAction(params)
        //如果是需要进行重定向
        if(res.mdata.redirectUrl) {
          sessionStorage.removeItem(qrCodeNo)
          sessionStorage.removeItem('accessHandleModeNo')
          window.location.href = res.mdata.redirectUrl
          return
        }
        //已经获取到第一次的动作了
        this.isFirstGetAction = false
        this.dataInfo = res.mdata
        /** 如果需要授权 先存储一下 授权之前的值 */
        localStorage.setItem('dataInfo', JSON.stringify(this.dataInfo))
        //处理显示的URL
        this.dealUrl()
        //通过后端返回的字段判断是否显示广告
        if(this.dataInfo.showAd) {
          this.showADFlag = true
          // this.isNotShownFlag = false
          //TODO 这个到时候填后端返回的广告标题就行了
          this.titleData()
          this.adSrc = this.dataInfo.adUrl
          console.log('扫码次数达到上限')
          return
        }
        this.dealAction()
      } catch (error) {
      }
    },
    /**
     * 处理显示的URL
     */
    dealUrl() {
      let newQuery = JSON.parse(JSON.stringify(this.$route.query))
      delete newQuery.session
      delete newQuery.SESSION
      delete newQuery.code
      delete newQuery.token
      if(this.dataInfo.accessHandleModeNo) {
        sessionStorage.setItem('accessHandleModeNo', this.dataInfo.accessHandleModeNo)
        sessionStorage.setItem(this.dataInfo.qrCodeNo, this.dataInfo.accessHandleModeNo)
        newQuery.accessHandleModeNo = this.dataInfo.accessHandleModeNo
      }
      this.$router.replace({
        name: this.$route.name,
        params: this.$route.params,
        query: newQuery
      })
    },
    /**
     * 跳过广告
     */
    jumpAD() {
      this.showADFlag = false
      this.dealAction()
    },
    /**
     * 处理动作
     */
    dealAction() {
      this.titleData(this.dataInfo.pageTitle)
      this.targetHandle()
    },
    //
    async changeBtn(obj){
      const params = {
        ...obj
      }
      await singlePageClick(params)
      this.getAction()
    },

    getQRCode(){
      new QRCode('qrCode',{
        width:200,
        height: 200,
        text: `${this.dataInfo.qrCodeContent}`, // 二维码地址
        colorDark : "#000",
        colorLight : "#fff",
      });
      const mycanvas1=document.getElementsByTagName('canvas')[0];
      const image = new Image();
      // canvas.toDataURL 返回的是一串Base64编码的URL
      image.src = mycanvas1.toDataURL("image/png");
      this.$refs.qrcode_box.append(image)
    },
    getWechatQrcode() {
      new QRCode('wechatQrCode',{
        width:300,
        height: 300,
        text: `${this.dataInfo.qrCodeUrl}`, // 二维码地址
        colorDark : "#000",
        colorLight : "#fff",
      })
      const mycanvas1=document.getElementsByTagName('canvas')[0];
      const image = new Image();
      // canvas.toDataURL 返回的是一串Base64编码的URL
      image.src = mycanvas1.toDataURL("image/png");
      setTimeout(() => {
        this.$refs.wechat_qrcode.append(image)
      }, 200)
    },
    // 跳转指定链接
    visit(){
      this.hrefOpen()
    },

    // 如果有schema，就尝试调用
    autoOpenApp(){
      if(this.dataInfo.targetType == 11 && this.dataInfo.appSchema){
        window.location = `${this.dataInfo.appSchema}`
      }
    },
    // 打开APP
    oppApp(){
       this.$refs.open_app.browserOpenApp(this.dataInfo)
       return
      // if(this.isWeChat){
      //   this.$refs.open_app.browserOpenApp(this.dataInfo)
      // }
      // const agent = navigator.userAgent;
      // const isIos = !!agent.match(/\Mac OS X/)
      // if(!isIos){
      //   if(this.dataInfo.androidDownloadType == 1){
      //     window.location=this.dataInfo.androidDownloadLink
      //     return
      //   }
      //   this.$refs.open_app.browserOpenApp(this.dataInfo)
      // }
      // if(isIos){
      //   if(this.dataInfo.iosDownloadType == 1){
      //     window.location=this.dataInfo.iosDownloadLink
      //     return
      //   }
      //   this.$refs.open_app.browserOpenApp(this.dataInfo)
      // }
    },

    // copy
   //复制成功的回调
    onCopy: e => {
      Toast.success({
        message: '复制成功',
        transition: '',
      });
    },
    //复制失败的回调
    onError: e => {
        Toast.success({
        message: '失败',
        transition: '',
      });
    },
    download(){
      let myCanvas = document.getElementsByTagName('canvas');
        let a = document.createElement('a')
        a.href = myCanvas[0].toDataURL('image/png');
        a.download = '二维码';
        a.click()
    },
    /**
     * 更改页面标题
     * @param newTitle
     */
    titleData(newTitle = '\u200b'){
      document.title = newTitle || '\u200b'
      const userAgent = window.navigator.userAgent.toLowerCase();

      if (/AlipayClient/i.test(userAgent) && ant) {
        ant.setTitle(newTitle || '\u200b');
      }
      if (/ip(hone|od|ad)/i.test(navigator.userAgent)) {
        var i = document.createElement('iframe');
        i.src = '/favicon.ico';
        i.style.display = 'none';
        i.onload = function() {
          setTimeout(function(){
            i.remove();
          }, 9)
        }
        document.body.appendChild(i);
      }
      this.$forceUpdate()
    },
    hrefOpen(){
      window.location.href = this.dataInfo.webLink
    },
    /**
     * 在支付宝中打开链接
     */
    openUrlWithAliPay() {
      window.location.href = 'alipays://platformapi/startapp?appId=20000067&url=' + this.dataInfo.webLink
    },
    /** 渲染 小程序 初始化 */
    initWechat(info) {
      const self = this
      self.loadingStatus = 'loading'
      setTimeout(() => {
        initWx({fullPath:this.$route.fullPath}).then(() => {
          let content = `
          <button class="wechat-btn">${ info.weChatMiniProgramButtonText }</button>
          <style>
            .wechat-btn{
              display: flex;
              align-items: center;
              justify-content: center;
              box-sizing: border-box;
              height: 40px;
              width: 300px;
              background: #007aff;
              border-radius: 20px;
              color: #fff;
              font-size: 16px;
              font-weight: 700;
              border: none;
              opacity: 0;
            }
          </style>
          `;
          wx_launch({eleId: 'launch-btn', appid: info.weChatMiniProgramOriginalId, url: info.weChatMiniProgramPath, content}).then(res => {
            self.loadingStatus = 'success'
            if(self.$route.query.session || self.$route.query.code) {
            let newQuery = JSON.parse(JSON.stringify(self.$route.query))
            delete newQuery.session
            delete newQuery.code
            self.$router.push({
              name: 'land',
              params: self.$route.params,
              query: newQuery
            })
            }
          })
        }).catch(err => {
          console.log(err, 'err----222')
          self.loadingStatus = 'error'
        })
      }, 100)
    },
    // 授权
    async getWechatPublicAuthorizationUrl(authorizationType = 0) {
      /** 存储授权方式 */
      localStorage.setItem('authorizationType', authorizationType)
      const dataStr = localStorage.getItem('dataInfo') || '{}'
      const dataInfo = JSON.parse(dataStr)
      const {protocol, pathname} = window.location
        //防止需要进行二次授权的时候把参数带进去
      const params = {
        // 协议类型，0代表“http”，1代表“https”
        agreement: Number(protocol.includes('https')),
        route:  pathname,
        //url类型，0代表静默授权，1代表非静默授权
        authorizationType,
        extraParam: {
          // domainRedirectFlag: 1,
          SESSION: getCookie('SESSION') || this.$route.query.session,
          oauthId: this.$route.query.oauthId,

        },
        appId: dataInfo.weChatPublicAppId,
        registerUserType: dataInfo.registerUserType,
      }
      const res = await getWechatPublicAuthorizationUrl(params)
      window.location.href = res.mdata.authorizationUrl
    },
    /** 是否授权成功 或需要二次授权 */
    async weChatPublicAuthLogin() {
      // 获取存储的授权方式 0 静默授权 1 强制授权
      const authorizationType = localStorage.getItem('authorizationType')
      const dataStr = localStorage.getItem('dataInfo') || '{}'
      const dataInfo = JSON.parse(dataStr)
      const params = {
        authorizationCode: this.$route.query.code,
        inviteCode: dataInfo.inviteCode,
        authorizationType: authorizationType == 0 ? dataInfo.weChatPublicAuthorizationType : 1,
        appId: dataInfo.weChatPublicAppId,
        registerUserType: dataInfo.registerUserType,
        qrCodeScanRecordNo: dataInfo.qrCodeScanRecordNo,
        userLoginType: '2',
        registerSourceType: '4'
      }
      try {
        const res = await newLogin(params)
        /** 授权成功 */
        if(res.mdata.token) {
          /** 和商品详情进行区别 授权 */
          localStorage.setItem('token', res.mdata.token)
          this.isFirstGetAction = false
        } else {
          localStorage.removeItem('token')
        }

        // 静默授权失败 进行强制授权
        if(dataInfo.weChatPublicAuthorizationType == 2 && res.mdata.noneSilentAuthFlag) {
          this.getWechatPublicAuthorizationUrl(1)
        } else {
          this.getAction()
        }
      } catch (error) {
        this.getAction()
      }
    },
    /** webview 通信 */
    postMessage(data) {
      /** 测试 通信 */
      uni.postMessage({
        data:data
      })
      document.addEventListener("UniAppJSBridgeReady", () => {
        uni.postMessage({
          data:data
        })
      })
    },
    /** 判断target */
    targetHandle() {
      if(this.dataInfo.targetType != 11){
        this.contentText =  this.dataInfo.pageTextContent
      }
      // 调用第三方
      if(this.dataInfo.targetType == 14){
        this.getAction()
      }
      if(this.dataInfo.targetType == 3){
          const image = new Image();
          // canvas.toDataURL 返回的是一串Base64编码的URL
          image.style = 'object-fit: contain; max-height: 80vh;max-width: 100vw;'
          image.src = this.dataInfo.showImgUrl
          this.$nextTick(() => {
            this.$refs.qrcode_image.append(image)
          })
      }
      // targetType  0打开微信公众号；1打开企业微信；2打开指定链接；3显示指定图片；4显示指定二维码；5显示二维码信息
      if(this.dataInfo.targetType == 2){
        this.hrefOpen()
      }
      //在支付宝中打开链接
      if(this.dataInfo.targetType == 21) {
        this.openUrlWithAliPay()
      }
      if(this.dataInfo.targetType == 0 || this.dataInfo.targetType == 1 || this.dataInfo.targetType == 4 || this.dataInfo.targetType == 5){
        this.$nextTick(()=>{
          this.getQRCode()
        })
      }
      // 初始化小程序
      if(this.dataInfo.targetType == 7 || this.dataInfo.targetType == 20) {
        //微信中打开链接
        if(this.dataInfo.targetType == 20) {
          const pathList = this.dataInfo.weChatMiniProgramPath.split('?url=')
          this.dataInfo.weChatMiniProgramPath = pathList.shift() + '?url=' + encodeURIComponent(pathList.join('?'))
          console.log(this.dataInfo.weChatMiniProgramPath, '转换之后的')
        }
          /** 判断当前是钱收收环境 还是其他浏览器环境 */
        this.openWechatMiniProgram()
      }
      // 打开公众号授权
      if(this.dataInfo.targetType ==12) {
        // 微信公众号授权类型：0静默授权；1非静默授权；2老用户静默，新用户非静默
        if(this.dataInfo.weChatPublicAuthorizationType == 0 || this.dataInfo.weChatPublicAuthorizationType == 2) {
          this.getWechatPublicAuthorizationUrl(0)
        }else if(this.dataInfo.weChatPublicAuthorizationType == 3) {
          //无需进行授权
          if(this.dataInfo.token) {
            localStorage.setItem('token', this.dataInfo.token)
          }
          this.getAction()
        }else {
          this.getWechatPublicAuthorizationUrl(1)
        }
      }
      // 打开指定商品

      if(this.dataInfo.targetType == 15) {
        // TODO 打开微信小程序有问题
        if(this.dataInfo.terminalType == '1'){
          this.openWechatMiniProgram()
        }
        if(this.dataInfo.terminalType == '2'){
          window.location.href= this.dataInfo.redirectUrl
        }
      }
      // 打开支付宝小程序
      if(this.dataInfo.targetType == 17) {
        this.postMessage({type: 'alipay'})
        window.location.href= this.dataInfo.redirectLink
      }
       // 关闭浏览器
      if(this.dataInfo.targetType == 19) {
        if(this.isWeChat) {
          wx.closeWindow();
        } else {
          this.closeWebPage()
        }
      }
      if(this.dataInfo.targetType == 22 || this.dataInfo.targetType == 23) {
        this.getWechatQrcode()
        // document.title = this.dataInfo.pageTitle || '\u200b'
      }
      this.autoOpenApp()
    },
    /**
     * 打开微信小程序
     */
    openWechatMiniProgram() {
      //钱收收环境
      if(this.$route.query.entry == 'qss') {
        this.postMessage({type: 'wechat', data: this.dataInfo})
        return
      }
      //微信环境
      if(this.isWeChat) {
        this.initWechat(this.dataInfo)
        return;
      }
      //其他环境，通过URL Scheme
      window.location.href =  this.dataInfo.weChatMiniProgramScheme || 'weixin://'
    },
    /** 钱收收授权登录 */
    async handleLoginApplication(auditType) {
      const params = {
        oauthId: this.$route.query.oauthId,
        auditType,
      }
      try {
        const res = await handleLoginApplication(params)
        if(auditType == 1) {
          Toast.fail({
            message: '拒绝登录',
            transition: '',
          });
        } else {
          Toast.success({
            message: '登录成功',
            transition: '',
          });
        }
        setTimeout(() => {
          this.getAction()
        }, 500)
      } catch (error) {
      } finally {
        console.log('重新触发')
        // this.getAction()
      }

    },
    closeWebPage() {
      if(this.$route.query.entry == 'qss') {
         this.postMessage({type: 'alipay'})
        return
      }

      if (navigator.userAgent.indexOf("MSIE") > 0) {
        if (navigator.userAgent.indexOf("MSIE 6.0") > 0) {
          window.opener = null; window.close();
        }
        else {
          window.open('', '_top'); window.top.close();
        }
      } else if (navigator.userAgent.indexOf("Firefox") > 0) {
          window.location.href = 'about:blank '; //火狐默认状态非window.open的页面window.close是无效的
      } else {
        // window.opener = null;
        // window.open('', '_self', '');
        // window.close();

        window.location.href = "about:blank";
        window.opener = null;
        window.open('about:blank', '_self', '').close();

      }
    },
    toURL() {
      window.location.href = this.dataInfo.techProviderUrl
    },
  },
}
</script>

<style scoped lang='less'>
.page-land {
  position: relative;
  min-height: 100vh;
  overflow: hidden;
}
.page-tips-area {
  -webkit-touch-callout:none; /*系统默认菜单被禁用*/
  -webkit-user-select:none; /*webkit浏览器*/
  -khtml-user-select:none; /*早期浏览器*/
  -moz-user-select:none;/*火狐*/
  -ms-user-select:none; /*IE10*/
  user-select:none;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 20px;
  font-size: 28px;
  background: #00C85E;
  color: #FFFFFF;
  .check-icon {
    width: 40px;
    height: 40px;
    margin-right: 20px;
  }
}
.ad-area {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  width: 100%;
  height: 100%;
  z-index: 100;
  background: #FFFFFF;
  .ad-box {
    overflow: auto;
    height: 100vh;
    width: 100vw;
    //解决白边
    line-height: 0;
    .class-iframe {
      min-height: 100vh;
      width: 100vw;
      border: none;
    }
    .ad-image {
      width: 100%;
    }
  }

  .close-box {
    position: absolute;
    right: 10px;
    top: 10px;
    .close-button {
      padding: 4px 30px;
      border-radius: 50px;
      background: rgba(#000, 0.5);
      color: #FFFFFF;
    }
  }
}
.wechat-id {
  display: flex;
  flex-direction: column;
  .info-area {
    display: flex;
    flex-direction: column;
    margin: 28px;
    padding: 30px 50px;
    background: #FFFFFF;
    border-radius: 20px;
    .info-box {
      display: flex;
      align-items: center;
      .avatar {
        flex-shrink: 0;
        width: 80px;
        height: 80px;
        margin-right: 20px;
      }
      .nickname {
        font-size: 40px;
        font-weight: bold;
      }
      .gender {
        flex-shrink: 0;
        width: 40px;
        height: 40px;
        margin-left: 10px;
      }
    }
    .qr-code-box {
      display: flex;
      justify-content: center;
      align-items: center;
      margin: 16px 0;
      .class-qrcode {
        display: flex;
        align-items: center;
        justify-content: center;
        width: 550px;
        height: 550px;
        &:nth-child(n) {
          width: 80%;
          height: 80%;
        }
      }
    }
    .time {
      align-self: center;
      font-size: 28px;
      color: #999999;
    }
  }
  .tips {
    margin: 30px 50px;
    align-self: center;
    text-align: center;
    font-size: 28px;
    color: #999999;
  }
  .service-box {
    //position: fixed;
    //bottom: 80px;
    //left: 0;
    //right: 0;
    display: flex;
    flex-direction: column;
    align-items: center;
    .service-item {
      font-size: 28px;
      color: #999999;
    }
  }
}
.qrcode-main{
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-top: 260px;
  .item-qrcode{
    width:80vw;
    padding-bottom: 100px;
    margin-top: -100px;
    color: #333;
    .item-copy{
      display: flex;
      justify-content: space-between;
      .copy-qrcode{
        width: 40px;
        height: 40px;
        margin-top: 5px;
      }
    }
    .qrcode-url{
      margin-top: 10px;
      word-break: break-all;
    }
  }
  .image{
    width: 360px;
    height: 360px;
  }
  .text-content{
    margin-top: 50px;
    text-align: center;
    font-size: 38px;
    word-break:break-all;
    white-space: pre-wrap;
    -webkit-touch-callout:none; /*系统默认菜单被禁用*/
    -webkit-user-select:none; /*webkit浏览器*/
    -khtml-user-select:none; /*早期浏览器*/
    -moz-user-select:none;/*火狐*/
    -ms-user-select:none; /*IE10*/
    user-select:none;
  }
  .qrcode-text{
    margin-top: -100px;
    margin-bottom: 100px;
  }
  .qrcode-item{
    position: relative;
    .download{
      position: absolute;
      width: 60px;
      height: 60px;
      right: -100px;
      margin-top: -60px;
    }
  }
}
// 小程序
.wecaht {
  width: 100%;
  display: flex;
  align-items: center;
  flex-direction: column;
  position: relative;
  &-img {
    width: 200px;
    height: 200px;
    border-radius: 20px;
  }
  .test-btn{
    display: flex;
    align-items: center;
    justify-content: center;
    box-sizing: border-box;
    height: 80px;
    width: 90%;
    background: #007aff;
    border-radius: 40px;
    color: #fff;
    font-size: 32px;
    font-weight: 700;
    border: none;
    margin-top: 100px;
  }
  .wechat-text-content {
    text-align: center;
    color: #999999;
    font-size: 28px;
  }
}
img {
  pointer-events: none;

}
.qrcode {
  pointer-events: all;
  display: none;
}

.qrcode-image{
  display: flex;
  justify-content: center;
  align-items: center;
  // position: fixed;
  // top: 0;
  width: 100vw;
  height: 80vh;
}
#launch-btn {
  position: absolute;

  left: 50%;
  transform: translateX(-50%);
  z-index: 1000;
}
.wechat-btn2 {
  display: flex;
  align-items: center;
  justify-content: center;
  box-sizing: border-box;
  background: #007aff;
  border-radius: 20px;
  color: #fff;
  font-weight: 700;
  border: none;
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
  z-index: 99;
}
.web-link{
  width: 100vw;
  .web-link-textarea{
    width: 666px;
    height: 300px;
    padding: 20px;
    margin:30px 20px;
    background-color: #fff;
    border-radius: 20px;
    border: 1px solid #ddd;
  }
  .visit{
    margin: 100px;
    padding: 20px;
    border-radius: 50px;
    background-color: #FD1576;
    color: #fff;
    text-align: center;
  }
}

.open-app{
  width: 100vw;
  display: flex;
  flex-direction: column;
  align-items: center;
  .view-app{
    width: 300px;
    height: 300px;
    margin: 60px 0;
    .app-icon{
      width: 300px;
      height: 300px;
      object-fit: contain;
    }
  }
  .open-app-btn-11{
    width: 100%;
    text-align: center;
    // display: flex;
    // align-items: center;
    // background: red;
    .button-text{
      margin: 0 16px;
      display: inline-block;
      word-break: break-all;
      padding: 12px 36px;
      color: #fff;
      border-radius: 36px;
      background-color: #3477f5;

      font-size: 38px;
    }
  }

  .text-content{
    margin: 20px;
    word-break:break-all;
    white-space: pre-wrap;
    font-size: 26px;
  }
  .view-img{
    .text-img{
      margin: 20px;
      width: 710px;
      object-fit: contain;
    }
  }
}
.iframe {
  position: fixed;
  top: -100000px;
}
.show-img-content{
  position: fixed;
  left: 0;
  right: 0;
  top: 82vh;
  text-align: center;
  word-break:break-all;
  margin: 0 20px;
  white-space: pre-wrap;

  overflow:hidden;
  text-overflow:ellipsis;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-box-pack: center;
  -webkit-box-align: center;
  -webkit-line-clamp:5;
}
// 钱收收授权登录
.action-qss-auth {
  margin: 0 auto;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  padding: 0 80px;
  .header {
    width: 150px;
    border-radius: 30px;
  }
  .name {
    padding: 20px 0;
    font-weight: 700;
    font-size: 40px;
  }
  .content {
    padding-bottom: 20px;
    font-size: 28px;
    color: #222;
  }
  .tip {
    font-size: 26px;
    color: #666;
    //width: 100%;
  }
  .btn-confirm, .btn-cancel {
    width: 100%;
    height: 80px;
    display: flex;
    align-items: center;
    justify-content: center;
    color: #fff;
    font-weight: 700;
    background: #007aff;
    margin-top: 60px;
    border-radius: 40px;
  }
  .btn-cancel {
    background: #fff;
    border: 1px solid #ebebeb;
    margin-top: 20px;
    color: #222;
  }
}

.copy-content{
  white-space: pre-wrap;
  padding: 30px;
}
.copy-show{
  display: flex;
  justify-content: center;
  margin-top: 30px;
  .copy-button{
    width: 500px;
    padding: 12px 30px;
    text-align: center;
    background-color: #00af00;
    border-radius: 50px;
    color: #fff;
    font-size: 30px;
    overflow:hidden;
	  text-overflow:ellipsis;
	  white-space:nowrap
  }
}
.page-footer {
  position: fixed;
  bottom: 16px;
  left: 0;
  right: 0;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  .tips {
    font-size: 28px;
    color: #999999;
    margin: 5px;
    .url-tips {
      color: #3477f5;
    }
  }
}
</style>
